import { render, staticRenderFns } from "./URLSChecker.vue?vue&type=template&id=649d4e7e&scoped=true&"
import script from "./URLSChecker.vue?vue&type=script&lang=js&"
export * from "./URLSChecker.vue?vue&type=script&lang=js&"
import style0 from "./URLSChecker.vue?vue&type=style&index=0&id=649d4e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649d4e7e",
  null
  
)

export default component.exports